import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-twitter-advanced-search-modal',
  templateUrl: './advanced-search-modal.component.html',
  styleUrls: ['./advanced-search-modal.component.less'],
})
export class TwitterAdvancedSearchModalComponent {
  @Input() close: Function;
  constructor() { }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/integrations/twitter/advanced-search-modal/advanced-search-modal.component.ts